import { z } from 'zod';
import type { TFunction } from 'i18next';
import { optionalOrEmpty } from '@/shared/utils/schemaHelpers';

const projectNameField = (t: TFunction) =>
  z
    .string()
    .min(1, t('projects:form.validation.nameRequired'))
    .max(200, t('projects:form.validation.nameTooLong'));

const projectDescriptionField = (t: TFunction) =>
  z
    .string()
    .max(500, t('projects:form.validation.descriptionMax', { max: 500 }))
    .optional();

export const createProjectSchema = (t: TFunction) =>
  z.object({
    name: projectNameField(t),
    color: z.string().optional(),
    description: projectDescriptionField(t),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
  });

export const updateProjectSchema = (t: TFunction) =>
  z.object({
    name: projectNameField(t).optional(),
    color: z.string().optional(),
    description: projectDescriptionField(t),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
  });

export type CreateProjectInput = z.infer<ReturnType<typeof createProjectSchema>>;
export type UpdateProjectInput = z.infer<ReturnType<typeof updateProjectSchema>>;

export const updateProjectInfoSchema = (t: TFunction) =>
  z.object({
    name: projectNameField(t),
    description: projectDescriptionField(t),
    color: z.string().optional(),
    startDate: optionalOrEmpty(z.string()),
    endDate: optionalOrEmpty(z.string()),
  });

export type UpdateProjectInfoInput = z.infer<ReturnType<typeof updateProjectInfoSchema>>;
